
import { useEffect, useState } from 'react';
import { SearchExpandType } from './types';
import { searchStore } from '@/shared/store/searchStore/searchStore';
import { useSearchParams } from 'next/navigation';
import { authStore } from '@/shared/store/authStore/authStore';



export function useSearchExpand() {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [activeSessions, setActiveSessions] = useState<SearchExpandType[]>([]);
  function onCloseModal(){
    // getActiveSessions();
    setOpenModal(false);
    // searchStore.sync.setClearAllMNN();
  }
  const searchParams = useSearchParams();

  const [sessionId, setSessionId] = useState<string>('');

  useEffect(() => {
    const id = searchParams.get("id") || '';
    searchStore.sync.setActiveSession(Number(id));
    setSessionId(id);
  }, [searchParams]);
  
  function onOpenModal(){
    setOpenModal(true);
  }

  async function getActiveSessions() {
    if(authStore.state.userInfo){
      const data = await searchStore.async.fetchGetActiveSessions() || [];
      const active: SearchExpandType[] = data.map((item) => {
        return {
          id: item.id,
          name: item.title,
          isActive: item.id === Number(sessionId),
          combination_mnn: item.combination_mnn
        };
      });
      setActiveSessions([...active]);
    }
  }

  useEffect(() => {
    getActiveSessions();
  }, [authStore.state.userInfo]);

  return {
    modal:{
      openModal,
      onOpenModal,
      onCloseModal,
    },
    getActiveSessions,
    activeSessions,
    sessionId,
  };
}
